import React from 'react';
import Fade from '@material-ui/core/Fade/Fade';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = () => ({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    zIndex: 2,
    backgroundColor: 'rgba(255,255,255,0.8)',
  },
  inner: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
  },
  '@keyframes preloader': {
    '0%': {
      transform: 'translateY(0)',
    },
    '50%': {
      opacity: 1,
      transform: 'translateY(-10px)',
    },
    '100%': {
      transform: 'translateY(0)',
    },
  },
  preloader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      position: 'absolute',
      width: 80,
      height: 80,
      backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 24 24'%3e%3cpath fill='%23000001' stroke='' d='M13.374 5.321l-0.787-0.48v-0.274c0-0.133-0.107-0.24-0.24-0.24v0h-0.077v-0.547c-0.006-0.126-0.060-0.239-0.144-0.322l-0-0c-0.090-0.082-0.209-0.132-0.34-0.134h-0.533c-0.25 0.018-0.446 0.226-0.446 0.479 0 0 0 0.001 0 0.001v-0 0.523h-0.062c-0.003-0-0.006-0-0.010-0-0.127 0-0.23 0.103-0.23 0.23 0 0.003 0 0.007 0 0.010l-0-0v13.171c-0.001 0.011-0.002 0.023-0.002 0.036s0.001 0.025 0.002 0.038l-0-0.002 0.816 2.693c0.030 0.101 0.122 0.173 0.23 0.173v0c0.108-0.002 0.199-0.073 0.23-0.171l0-0.002 0.816-2.698c0.001-0.010 0.002-0.022 0.002-0.034s-0.001-0.024-0.002-0.035l0 0.001v-12.341l0.422 0.259v2.962c0 0.133 0.107 0.24 0.24 0.24v0c0.133 0 0.24-0.107 0.24-0.24v0-3.096c-0.002-0.087-0.052-0.162-0.124-0.201l-0.001-0.001zM11.53 19.586l-0.576-1.92v-7.027h1.138v7.042z'/%3e%3c/svg%3e\")",
      animation: '$preloader 1s infinite ease-in-out',
      opacity: 1,
    },

    '& span.two': {
      backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 24 24'%3e%3cpath fill='%23000001' stroke='' d='M13.374 5.321l-0.787-0.48v-0.274c0-0.133-0.107-0.24-0.24-0.24v0h-0.077v-0.547c-0.006-0.126-0.060-0.239-0.144-0.322l-0-0c-0.090-0.082-0.209-0.132-0.34-0.134h-0.533c-0.25 0.018-0.446 0.226-0.446 0.479 0 0 0 0.001 0 0.001v-0 0.523h-0.062c-0.003-0-0.006-0-0.010-0-0.127 0-0.23 0.103-0.23 0.23 0 0.003 0 0.007 0 0.010l-0-0v13.171c-0.001 0.011-0.002 0.023-0.002 0.036s0.001 0.025 0.002 0.038l-0-0.002 0.816 2.693c0.030 0.101 0.122 0.173 0.23 0.173v0c0.108-0.002 0.199-0.073 0.23-0.171l0-0.002 0.816-2.698c0.001-0.010 0.002-0.022 0.002-0.034s-0.001-0.024-0.002-0.035l0 0.001v-12.341l0.422 0.259v2.962c0 0.133 0.107 0.24 0.24 0.24v0c0.133 0 0.24-0.107 0.24-0.24v0-3.096c-0.002-0.087-0.052-0.162-0.124-0.201l-0.001-0.001zM11.53 19.586l-0.576-1.92v-7.027h1.138v7.042z'/%3e%3c/svg%3e\")",
      marginLeft: '-30px',
      animationDelay: '.2s',
    },

    '& span.three': {
      backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 24 24'%3e%3cpath fill='%23000001' stroke='' d='M13.374 5.321l-0.787-0.48v-0.274c0-0.133-0.107-0.24-0.24-0.24v0h-0.077v-0.547c-0.006-0.126-0.060-0.239-0.144-0.322l-0-0c-0.090-0.082-0.209-0.132-0.34-0.134h-0.533c-0.25 0.018-0.446 0.226-0.446 0.479 0 0 0 0.001 0 0.001v-0 0.523h-0.062c-0.003-0-0.006-0-0.010-0-0.127 0-0.23 0.103-0.23 0.23 0 0.003 0 0.007 0 0.010l-0-0v13.171c-0.001 0.011-0.002 0.023-0.002 0.036s0.001 0.025 0.002 0.038l-0-0.002 0.816 2.693c0.030 0.101 0.122 0.173 0.23 0.173v0c0.108-0.002 0.199-0.073 0.23-0.171l0-0.002 0.816-2.698c0.001-0.010 0.002-0.022 0.002-0.034s-0.001-0.024-0.002-0.035l0 0.001v-12.341l0.422 0.259v2.962c0 0.133 0.107 0.24 0.24 0.24v0c0.133 0 0.24-0.107 0.24-0.24v0-3.096c-0.002-0.087-0.052-0.162-0.124-0.201l-0.001-0.001zM11.53 19.586l-0.576-1.92v-7.027h1.138v7.042z'/%3e%3c/svg%3e\")",
      animationDelay: '.4s',
      marginLeft: '30px',
    },

  },

});

/*
.klio-preloader {
  z-index: 999;
}
/* MODAL Preloader STYLING

#load-preloader-time .modal-backdrop
{
  / opacity:0.5 !important; /
  background-color: #222222;

}

#load-preloader-time .modal-content {
border: 0 solid rgba(0, 0, 0, 0.2);
border-radius: 0.3rem;
outline: 0;
opacity: .8;
}
*/

export default withStyles(styles, { name: 'Progress' })(({ loading, classes }) => (
  <Fade
    in={loading}
    timeout={700}
    style={{
      transitionDelay: loading ? '300ms' : '0ms',
    }}
    unmountOnExit
  >
    <div className={classes.container}>
      <div className={classes.inner}>
        <div className={classes.preloader}>
          <span />
          <span className="two" />
          <span className="three" />
        </div>
      </div>
    </div>
  </Fade>
));
